(function () {
  var doc = document;
  if (!doc) return;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function hydrateVideo(video) {
    if (!video || video.dataset.lazyLoaded === 'true') return;
    var sources = toArray(video.querySelectorAll('source[data-src]'));
    sources.forEach(function (source) {
      var src = source.getAttribute('data-src');
      if (!src) return;
      source.src = src;
      source.removeAttribute('data-src');
    });
    video.load();
    if (video.autoplay && typeof video.play === 'function') {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () { });
      }
    }
    video.dataset.lazyLoaded = 'true';
  }

  var videos = toArray(doc.querySelectorAll('video[data-lazy]'));
  if (videos.length) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.intersectionRatio <= 0) return;
          var target = entry.target;
          observer.unobserve(target);
          hydrateVideo(target);
        });
      }, { rootMargin: '600px 0px' });
      videos.forEach(function (video) { observer.observe(video); });
    } else {
      videos.forEach(hydrateVideo);
    }
  }

  // Slideshow video lazy-load: hydrate when slide becomes visible (hidden attr removed)
  var slideItems = toArray(doc.querySelectorAll('slide-show-item'));
  if (slideItems.length && 'MutationObserver' in window) {
    var slideObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName !== 'hidden') return;
        var item = mutation.target;
        if (item.hasAttribute('hidden')) return;
        toArray(item.querySelectorAll('video[data-lazy-slide]')).forEach(function (video) {
          video.removeAttribute('data-lazy-slide');
          hydrateVideo(video);
        });
      });
    });
    slideItems.forEach(function (item) {
      slideObserver.observe(item, { attributes: true, attributeFilter: ['hidden'] });
    });
  }

  var images = toArray(doc.querySelectorAll('img:not([loading])'));
  images.forEach(function (img) {
    if (!img) return;
    if (img.dataset.lazyExclude === 'true') return;
    if (img.closest('[data-lazy-critical]')) return;
    if (img.closest('header') || img.closest('.hero')) return;
    img.setAttribute('loading', 'lazy');
  });
})();
